import React from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { IoIosCall } from 'react-icons/io';
import { HiOutlineArrowNarrowRight, HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import sliderImage01 from '../../assets/slider/slider-03.jpg';
import sliderImage02 from '../../assets/slider/slider-02.jpg';
import sliderImage03 from '../../assets/slider/slider-01.jpg';
import './Banner.css';

/* ─── Slider data ─────────────────────────────────── */
const SLIDES = [
  {
    id: 1,
    image: sliderImage02,
    title: 'Top-quality roofing built for longevity',
    desc: 'Top-quality, durable roofing solutions built to last. Expert craftsmanship for long-term protection.',
  },
  {
    id: 2,
    image: sliderImage01,
    title: 'Expert repairs & storm damage restoration',
    desc: 'Fast, reliable emergency roofing repairs when you need them most. Securing your home against the elements.',
  },
  {
    id: 3,
    image: sliderImage03,
    title: 'Your roofing journey starts right here',
    desc: 'Central Industries Kandy — your trusted gateway to premium roofing materials, gates, and steel products.',
  },
];

/* ─── Carousel Settings ───────────────────────────── */
const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 900,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

/* ─── Custom Arrows ───────────────────────────────── */
function NextArrow({ onClick }) {
  return (
    <button className="banner__arrow banner__arrow--next" onClick={onClick} aria-label="Next slide">
      <HiOutlineArrowNarrowRight />
    </button>
  );
}

function PrevArrow({ onClick }) {
  return (
    <button className="banner__arrow banner__arrow--prev" onClick={onClick} aria-label="Previous slide">
      <HiOutlineArrowNarrowLeft />
    </button>
  );
}

/* ─── Individual Slide ────────────────────────────── */
function SliderElement({ image, title, desc }) {
  return (
    <div className="banner" id="Home" style={{ backgroundImage: `url('${image}')` }}>
      <div className="banner__content-wrapper">
        <div className="banner__content">

          <motion.h2
            className="banner__title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {title}
          </motion.h2>

          <motion.p
            className="banner__description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            {desc}
          </motion.p>

          <motion.div
            className="banner__actions"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <a href="#Contact" className="btn btn-primary" aria-label="Get a free estimate">
              <span>Get a free estimate</span>
            </a>

            <a href="tel:+94763607727" className="banner__phone-cta" aria-label="Call us">
              <IoIosCall aria-hidden="true" />
              <span>+94 (76) 360-7727</span>
            </a>
          </motion.div>

        </div>
      </div>
    </div>
  );
}

/* ─── Main Banner Component ───────────────────────── */
function Banner() {
  return (
    <Slider {...sliderSettings}>
      {SLIDES.map((slide) => (
        <SliderElement
          key={slide.id}
          image={slide.image}
          title={slide.title}
          desc={slide.desc}
        />
      ))}
    </Slider>
  );
}

export default Banner;